import axios from 'axios';

const API_URL = 'http://localhost:9000';

const ImageCacheAPIService = {
    async cacheProducts(products) {
        try {
            let successCount = 0;
            let errorCount = 0;

            for (const product of products) {
                if (product.image_base64 && product.id) {
                    try {
                        await axios.post(
                            `${API_URL}/images/cache/${product.id}`,
                            {
                                imageData: product.image_base64,
                                mimeType: 'image/jpeg'
                            },
                            { timeout: 5000 }
                        );
                        successCount++;
                    } catch (error) {
                        console.error(`Error cacheando imagen ${product.id}:`, error.message);
                        errorCount++;
                    }
                }
            }

            console.log(`Cache API: ${successCount} imagenes guardadas, ${errorCount} errores`);
            return { success: successCount, errors: errorCount };

        } catch (error) {
            console.error('Error en cache masivo:', error);
            return { success: 0, errors: products.length };
        }
    },

    async fetchAndCacheBanners(products) {
        let successCount = 0;
        let skippedCount = 0;
        let errorCount = 0;

        for (const product of products) {
            if (!product.id) continue;
            try {
                const response = await fetch(
                    `${API_URL}/api/products/${product.id}/banner`,
                    { signal: AbortSignal.timeout(8000) }
                );
                if (response.status === 404) {
                    skippedCount++;
                    continue;
                }
                if (!response.ok) {
                    errorCount++;
                    continue;
                }
                const data = await response.json();
                if (data?.success && data?.banner_base64) {
                    successCount++;
                } else {
                    skippedCount++;
                }
            } catch (error) {
                errorCount++;
            }
        }

        console.log(`Banners: ${successCount} cacheados, ${skippedCount} sin banner, ${errorCount} errores`);
        return { success: successCount, skipped: skippedCount, errors: errorCount };
    },

    async cacheCategories(categories) {
        let successCount = 0;
        let skippedCount = 0;
        let errorCount = 0;

        for (const category of categories) {
            const imageData = category.category_image || category.totem_image || category.image || category.image_base64 || category.image_1920 || category.image_128 || category.image_256 || category.image_512;
            if (!category.id || !imageData) {
                skippedCount++;
                continue;
            }
            try {
                await axios.post(
                    `${API_URL}/images/cache/categories/${category.id}`,
                    { imageData },
                    { timeout: 5000 }
                );
                successCount++;
            } catch (error) {
                console.error(`Error cacheando imagen categoría ${category.id}:`, error.message);
                errorCount++;
            }
        }

        console.log(`Categorías: ${successCount} imágenes cacheadas, ${skippedCount} sin imagen, ${errorCount} errores`);
        return { success: successCount, skipped: skippedCount, errors: errorCount };
    },

    // Cachea las imágenes de los productos bebida (drinks) encontrados en los grupos de combos
    async cacheDrinkImages(comboGroupsMap) {
        // comboGroupsMap: { [productId]: { has_combos, combo_groups: [...] } }
        const seenDrinkIds = new Set();
        const drinksToCache = [];

        for (const entry of Object.values(comboGroupsMap)) {
            if (!entry?.has_combos) continue;
            for (const group of (entry.combo_groups || [])) {
                for (const drink of (group.drink_group?.products || [])) {
                    if (drink.id && drink.image_base64 && !seenDrinkIds.has(drink.id)) {
                        seenDrinkIds.add(drink.id);
                        drinksToCache.push({ id: drink.id, image_base64: drink.image_base64 });
                    }
                }
            }
        }

        if (drinksToCache.length === 0) return { success: 0, skipped: 0 };

        let successCount = 0;
        let skippedCount = 0;

        for (const drink of drinksToCache) {
            try {
                await axios.post(
                    `${API_URL}/images/cache/${drink.id}`,
                    { imageData: drink.image_base64, mimeType: 'image/jpeg' },
                    { timeout: 5000 }
                );
                successCount++;
            } catch {
                skippedCount++;
            }
        }

        console.log(`Drinks: ${successCount} imágenes cacheadas, ${skippedCount} errores`);
        return { success: successCount, skipped: skippedCount };
    },

    async getCacheStats() {
        try {
            const response = await axios.get(`${API_URL}/images/cache/stats`, { timeout: 3000 });
            return response.data;
        } catch (error) {
            console.error('Error obteniendo stats:', error);
            return null;
        }
    },

    async clearCache() {
        try {
            await axios.delete(`${API_URL}/images/cache`, { timeout: 3000 });
            console.log('Cache limpiado en API intermedia');
            return true;
        } catch (error) {
            console.error('Error limpiando cache:', error);
            return false;
        }
    }
};

export default ImageCacheAPIService;